import { useState } from 'react';
import { db, storage } from '../../lib/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuid } from 'uuid';

const useAddProduct = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const uploadImage = async (fileOrUrl, index) => {
    if (!fileOrUrl) return null;

    // If it's already a URL (starts with http), skip uploading
    if (typeof fileOrUrl === 'string' && fileOrUrl.startsWith('http')) {
      return fileOrUrl;
    }

    const file = fileOrUrl instanceof File ? fileOrUrl : null;
    if (!file) return null;

    const storageRef = ref(storage, `products/${uuid()}-${file.name}`);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  };

  const addProduct = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Upload images and get URLs
      const imageUrls = await Promise.all(
        formData.images.map((img, i) => uploadImage(img, i))
      );

      const product = {
        name: formData.name,
        brand: formData.brand,
        category: formData.category,
        sku: formData.sku,
        description: formData.description,
        price: parseFloat(formData.price),
        quantity: parseInt(formData.quantity),
        releaseDate: formData.releaseDate,
        tags: formData.tags.split(',').map((tag) => tag.trim().toLowerCase()),
        featured: formData.featured,
        inStock: formData.inStock,
        sale: formData.sale,
        imageUrl: imageUrls[0] || '',
        images: imageUrls,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      };

      await addDoc(collection(db, 'products'), product);
      setSuccess(true);
    } catch (err) {
      console.error('Add product error:', err);
      setError(err.message || 'Failed to add product.');
    } finally {
      setLoading(false);
    }
  };

  return {
    addProduct,
    loading,
    error,
    success,
  };
};

export default useAddProduct;
